import React, {useEffect, useState} from "react";
import {Outlet, Navigate, useLocation, Route} from "react-router-dom";
import {useSelector, useDispatch} from "react-redux";
import {AUTH_TOKEN, USER_ROLE} from "../../constants/Auth";
import {getUserInfo, setCurrentPath} from '../../redux/dataUploader/dataSlice';
import routeConfig from "../index";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import NotificationPopups from "../../components/popups/NotificationPopups";
import NotFound from "../../pages/NotFound";
import {getTrackdeskAccess} from "../../services/postbacks";

const AuthWrapper = () => {
    const currentUserRole = localStorage.getItem(USER_ROLE);
    const token = useSelector((state) => state.dataUploader.token);
    const menuStatus = useSelector(state => state.dataUploader.collapseMenu);
    const {pathname} = useLocation();
    const dispatch = useDispatch();
    const localToken = localStorage.getItem(AUTH_TOKEN);
    const [trackdeskAccess, setTrackdeskAccess] = useState({allowed: false, loaded: false});
    //TODO получить второе значение pathname что-бы понять что это за страница

    useEffect(() => {
        if (pathname !== '/reset-password') {
            if (pathname !== '/login/') {
                dispatch(setCurrentPath(pathname))
            } else if (token && pathname !== '/login/') {
                dispatch(getUserInfo())
            }
        }
    }, [token, localToken, dispatch, pathname])

    useEffect(() => {
        let cancelled = false;

        if (!token || !localToken) {
            setTrackdeskAccess({allowed: false, loaded: true});
            return undefined;
        }

        setTrackdeskAccess({allowed: false, loaded: false});

        getTrackdeskAccess(localToken)
            .then((response) => {
                if (!response.ok) {
                    return Promise.reject(response);
                }

                return response.json();
            })
            .then((response) => {
                if (!cancelled) {
                    setTrackdeskAccess({allowed: response.allowed === true, loaded: true});
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setTrackdeskAccess({allowed: false, loaded: true});
                }
            });

        return () => {
            cancelled = true;
        };
    }, [token, localToken]);

    if (pathname !== '/reset-password') {
        if (!token && pathname !== '/login/') {
            return (
                <Navigate to="/login/"/>
            )
        }
    }

    if (pathname === '/postback-trackdesk/' || pathname === '/postback-trackdesk') {
        if (!trackdeskAccess.loaded) {
            return null;
        }

        if (!trackdeskAccess.allowed) {
            return <Navigate to="/" replace/>;
        }
    }

    const handleProtectedRoute = () => {
        for (let i = 0; i < routeConfig.length; i++) {
            if (pathname === routeConfig[i].path) {
                if (!routeConfig[i]?.role || routeConfig[i]?.role.includes(currentUserRole)) {
                    return (
                        <>
                            {pathname !== '/login/' && pathname !== '/reset-password' ?
                                <>
                                    <Header/>
                                    <Sidebar hasTrackdeskAccess={trackdeskAccess.allowed}/>
                                    <NotificationPopups/>
                                </>
                                : null
                            }
                            <div className={`container page-container${!menuStatus ? ' collapsed-menu' : ''}`}>
                                <Outlet/>
                            </div>
                        </>
                    )
                } else if (!routeConfig[i]?.role.includes(currentUserRole)) {
                    return <Navigate to={"/"}/>
                }
            }
        }

        return (
            <>
                <>
                    <Header/>
                    <Sidebar hasTrackdeskAccess={trackdeskAccess.allowed}/>
                </>
                <div className={`container page-container${!menuStatus ? ' collapsed-menu' : ''}`}>
                    <Outlet/>
                </div>
            </>
        )
    }

    return handleProtectedRoute();
};
export default AuthWrapper;
